import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { LanguageCode } from './config/locale';
import { translationsByModule } from './locales/modules';

const supportedLanguages: LanguageCode[] = ['en', 'fr', 'es', 'de'];

const resources = supportedLanguages.reduce((acc, lng) => {
  const translation: Record<string, unknown> = {};

  (Object.keys(translationsByModule) as Array<keyof typeof translationsByModule>).forEach(
    (moduleKey) => {
      translation[moduleKey] = translationsByModule[moduleKey][lng];
    },
  );

  acc[lng] = { translation };
  return acc;
}, {} as Record<LanguageCode, { translation: Record<string, unknown> }>);

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    supportedLngs: supportedLanguages,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'lewouhmart_lang',
    },
  });

export default i18n;

